<script lang="ts">
	import {
		startOfMonth,
		startOfYear,
		startOfWeek,
		endOfMonth,
		endOfWeek,
		endOfYear,
		addDays,
		endOfDay,
		isSameDay,
	} from "date-fns";
	import { createEventDispatcher } from "svelte";
	import { DefaultBadge } from "@hitit/new_ui";
	import { t } from "../../../stores";

	const dispatch = createEventDispatcher();

	export let today: Date;
	export let range = {
		start: new Date(),
		end: new Date(),
	};

	$: selectedToday =
		isSameDay(today, range.start) && isSameDay(today, range.end);
	$: selectedYesterday =
		isSameDay(addDays(today, -1), range.start) &&
		isSameDay(addDays(today, -1), range.end);
	$: selectedWeek =
		isSameDay(startOfWeek(today), range.start) &&
		isSameDay(endOfWeek(today), range.end);
	$: selectedMonth =
		isSameDay(startOfMonth(today), range.start) &&
		isSameDay(endOfMonth(today), range.end);
	$: selectedYear =
		isSameDay(startOfYear(today), range.start) &&
		isSameDay(endOfYear(today), range.end);

	function setRange(range: { start: Date; end: Date }) {
		dispatch("change", range);
	}

	function setToday() {
		setRange({
			start: today,
			end: endOfDay(today),
		});
	}
	function setYesterday() {
		setRange({
			start: addDays(today, -1),
			end: endOfDay(addDays(today, -1)),
		});
	}
	function setWeek() {
		setRange({
			start: startOfWeek(today),
			end: endOfWeek(today),
		});
	}
	function setMonth() {
		setRange({
			start: startOfMonth(today),
			end: endOfMonth(today),
		});
	}
	function setYear() {
		setRange({
			start: startOfYear(today),
			end: endOfYear(today),
		});
	}

</script>

<div class="range-presets">
	<DefaultBadge
		active={selectedToday}
		text={$t('global.time.today')}
		on:click={setToday} />
	<DefaultBadge
		active={selectedYesterday}
		text={$t('global.time.yesterday')}
		on:click={setYesterday} />
	<DefaultBadge
		active={selectedWeek}
		text={$t('global.time.thisweek')}
		on:click={setWeek} />
	<DefaultBadge
		active={selectedMonth}
		text={$t('global.time.thismonth')}
		on:click={setMonth} />
	<DefaultBadge
		active={selectedYear}
		text={$t('global.time.thisyear')}
		on:click={setYear} />
</div>

<style lang="scss">
	.range-presets {
		display: flex;
		flex-wrap: wrap;
		gap: 12px 10px;
	}

</style>
